// Pin a game object and everything inside it to the camera (scroll factor 0). Phaser's own
// Container.setScrollFactor(x, y, true) only updates children that carry scrollFactorX as an OWN
// property, which Rectangle / Graphics / Text don't (it lives on their prototype): they render
// pinned (the container renderer multiplies) but hit-test in world space, so a pinned button on
// the scrolling street could not be clicked.
export function pinToCamera(obj) {
  obj.setScrollFactor(0, 0);
  for (const child of obj.list ?? []) pinToCamera(child);
  return obj;
}
